import { Navigate, Route, Routes } from 'react-router-dom';

import { useAuth } from './auth/auth-context';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { CurrentRouterProvider } from './lib/current-router';
import { AuditPage } from './pages/AuditPage';
import { BillingPage } from './pages/BillingPage';
import { DashboardPage } from './pages/DashboardPage';
import { HealthPage } from './pages/HealthPage';
import { HotspotUsersPage } from './pages/HotspotUsersPage';
import { LoginPage } from './pages/LoginPage';
import { MyBillingPage } from './pages/MyBillingPage';
import { NetworkPage } from './pages/NetworkPage';
import { PanelUsersPage } from './pages/PanelUsersPage';
import { PerformancePage } from './pages/PerformancePage';
import { PlansPage } from './pages/PlansPage';
import { PppoeClientsPage } from './pages/PppoeClientsPage';
import { RoutersPage } from './pages/RoutersPage';
import { SessionsPage } from './pages/SessionsPage';
import { VouchersPage } from './pages/VouchersPage';

export function App() {
  const { profile, loading, hasRole } = useAuth();

  // Mientras se valida el token guardado no se puede decidir: mostrar el login aquí haría
  // parpadear la pantalla de acceso en cada recarga.
  if (loading) {
    return (
      <div className="login-screen">
        <Spinner label="Comprobando sesión…" />
      </div>
    );
  }

  if (!profile) return <LoginPage />;

  const isAdmin = hasRole('SUPER_ADMIN');

  return (
    <Routes>
      <Route
        element={
          <CurrentRouterProvider>
            <Layout />
          </CurrentRouterProvider>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/hotspot-users" element={<HotspotUsersPage />} />
        <Route path="/pppoe-clients" element={<PppoeClientsPage />} />
        <Route path="/vouchers" element={<VouchersPage />} />
        <Route path="/sessions" element={<SessionsPage />} />
        <Route path="/my-billing" element={<MyBillingPage />} />
        <Route path="/performance" element={<PerformancePage />} />
        <Route path="/network" element={isAdmin ? <NetworkPage /> : <Navigate to="/" replace />} />
        <Route path="/routers" element={isAdmin ? <RoutersPage /> : <Navigate to="/" replace />} />
        <Route path="/plans" element={isAdmin ? <PlansPage /> : <Navigate to="/" replace />} />
        {/* Las rutas de administración no se registran para un operador: el backend las
            rechazaría igualmente, pero así tampoco aparecen como páginas en blanco. */}
        <Route
          path="/panel-users"
          element={isAdmin ? <PanelUsersPage /> : <Navigate to="/" replace />}
        />
        <Route path="/audit" element={isAdmin ? <AuditPage /> : <Navigate to="/" replace />} />
        <Route path="/billing" element={isAdmin ? <BillingPage /> : <Navigate to="/" replace />} />
        <Route path="/health" element={isAdmin ? <HealthPage /> : <Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
